<template>
  <div class="custom-popover" v-click-outside="hide">
    <div ref="item" :id="idCalc" aria-describedby="tooltip" class="item">
      <Btn :disabled="disabled" :variant="variant" @click="toggle">
        <slot name="button" />
      </Btn>
    </div>
    <div ref="content" :id="`${idCalc}-content`" role="tooltip" class="content">
      <slot name="body" v-if="showContent" />
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import Btn from "@/components/display/Btn";
import { createPopper } from "@popperjs/core";
import uniqueId from "lodash-es/uniqueId";

export default {
  name: "DropDownButton",
  components: {
    Btn,
  },
  props: {
    variant: String,
    placement: {
      type: String,
      default: "bottom",
    },
    disabled: Boolean,
  },
  setup(props) {
    const POSITIONS = {
      left: "left",
      right: "right",
      top: "top",
      bottom: "bottom",
    };

    const content = ref(null);
    const instance = ref(null);
    const item = ref(null);
    const showContent = ref(false);
    const idCalc = computed(() => props.id || uniqueId("dropdown-"));
    const position = computed(() => POSITIONS[props.placement]);

    const toggle = () => (showContent.value ? hide() : show());

    const show = () => {
      showContent.value = true;
      content.value.setAttribute("data-show", "");
      instance.value.update();
    };

    const hide = () => {
      showContent.value = false;
      content.value.removeAttribute("data-show");
    };

    onMounted(() => {
      instance.value = createPopper(item.value, content.value, {
        placement: position.value,
      });
    });

    return {
      content,
      idCalc,
      item,
      hide,
      showContent,
      toggle,
    };
  },
};
</script>

<style lang="scss" scoped>
.custom-popover {
  @apply tw-inline-block;

  .item {
    @apply tw-inline-block;
  }

  .content {
    @apply tw-bg-beta tw-text-alpha tw-border-nu;
    display: none;
    text-align: left;
    max-width: 25rem;
    width: auto;
    padding: 0.125rem;
    position: absolute;
    font-size: 14px;
    font-weight: normal;
    z-index: 200000;

    &[data-show] {
      display: block;
    }
  }
}
</style>
